import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

export default function CustomerHeader({ onRefresh, onAdd }) {
    return (
        <Box
            sx={{
                py: { xs: 3, md: 4 },
                borderBottom: "1px solid",
                borderColor: "divider",
                background: "linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)",
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
                            Kundenverwaltung
                        </Typography>
                        <Typography variant="subtitle1" sx={{ mt: 0.5 }}>
                            Kunden anlegen, Bank- und Adressdaten pflegen – schnell &amp; übersichtlich.
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                        <Button variant="outlined" startIcon={<RefreshRoundedIcon />} onClick={onRefresh}>
                            Aktualisieren
                        </Button>
                        <Button
                            variant="contained"
                            onClick={onAdd}
                            startIcon={<AddRoundedIcon />}
                            sx={{
                                backgroundColor: "orange",
                                color: "#000",
                                fontWeight: 800,
                                "&:hover": { backgroundColor: "#ff9e1a" },
                            }}
                        >
                            Kunde hinzufügen
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
